const animatedNumberInit = (block) => {
    const counters = block ? [block[0].querySelector(".bn-animated-number__number")] : Array.from(document.querySelectorAll('.bn-animated-number__number'));

    if (!counters) return;

    const duration = 2000; // Fixed animation length (ms) regardless of the target value.

    // Decelerating count: fast at first, easing into the final value.
    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

    // Formats the value for display. `format` comes from data-format:
    //   plain     -> 1000
    //   separator -> 1 000   (pl-PL grouping)
    //   short     -> 1k / 1,5k / 2,5M
    const formatNumber = (value, format) => {
        const v = Math.round(value);

        if ('short' === format) {
            const abbreviate = (n, divisor, unit) => {
                const scaled = n / divisor;
                return (Math.abs(scaled) % 1 ? scaled.toFixed(1) : scaled.toFixed(0)) + unit;
            };
            if (Math.abs(v) >= 1e6) return abbreviate(v, 1e6, 'M');
            if (Math.abs(v) >= 1e3) return abbreviate(v, 1e3, 'k');
            return String(v);
        }

        if ('separator' === format) return v.toLocaleString('pl-PL');

        return String(v);
    };

    counters.forEach(counter => {
        if (!counter) return;

        const target = parseInt(counter.dataset.number, 10) || 0;
        const format = counter.dataset.format || 'plain';

        const startCounting = () => {
            let startTime = null;

            const tick = (now) => {
                if (null === startTime) startTime = now;
                const progress = Math.min((now - startTime) / duration, 1);
                counter.textContent = formatNumber(target * easeOutCubic(progress), format);

                if (progress < 1) {
                    requestAnimationFrame(tick);
                } else {
                    counter.textContent = formatNumber(target, format);
                }
            };

            requestAnimationFrame(tick);
        };

        const observer = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                startCounting();
                observer.disconnect();
            }
        });
        observer.observe(counter);
    });
}

document.addEventListener("DOMContentLoaded", function () {
    if (document.body && !document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body'))
        animatedNumberInit();
    else if (window.acf)
        window.acf.addAction('render_block_preview/type=bn/animated-number', animatedNumberInit);
});
